module.exports = __webpack_public_path__ + "static/media/five-states-of-ready-thumbnail.77d89fe0.png";